<mat-toolbar>
	<ng-content></ng-content>
	<span></span>
	<img *ngIf="logoPath" [src]="logoPath" class="sh-footer-shure-logo" />
</mat-toolbar>
